import { types as coreTypes } from '@sitebuilder/core';

export const defaultFonts: coreTypes.Fonts[] = [
    {
        name: 'OpenSans-Regular',
        src: '../../assets/fonts/OpenSans-Regular.ttf',
        format: 'truetype',
        fontWeight: '400',
        fontStyle: 'normal',
        fontDisplay: 'normal',
    },
    {
        name: 'OpenSans-Light',
        src: '../../assets/fonts/OpenSans-Light.ttf',
        format: 'truetype',
        fontWeight: '300',
        fontStyle: 'normal',
        fontDisplay: 'normal',
    },
    {
        name: 'OpenSans-Medium',
        src: '../../assets/fonts/OpenSans-Medium.ttf',
        format: 'truetype',
        fontWeight: '500',
        fontStyle: 'normal',
        fontDisplay: 'normal',
    },
    {
        name: 'OpenSans-SemiBold',
        src: '../../assets/fonts/OpenSans-SemiBold.ttf',
        format: 'truetype',
        fontWeight: '600',
        fontStyle: 'normal',
        fontDisplay: 'normal',
    },
    {
        name: 'OpenSans-Bold',
        src: '../../assets/fonts/OpenSans-Bold.ttf',
        format: 'truetype',
        fontWeight: '700',
        fontStyle: 'normal',
        fontDisplay: 'normal',
    },
    {
        name: 'OpenSans-ExtraBold',
        src: '../../assets/fonts/OpenSans-ExtraBold.ttf',
        format: 'truetype',
        fontWeight: '900',
        fontStyle: 'normal',
        fontDisplay: 'normal',
    },
];
